import {
  EDIT_SUBSCRIPTION, DELETE_SUBSCRIPTION, CREATE_SUBSCRIPTION, CREATE_SUBSCRIPTION_SUCCESS, UPDATE_SUBSCRIPTION_SUCCESS,
  UPDATE_SUBSCRIPTION, DELETE_SUBSCRIPTION_SUCCESS, FETCH_ALL_SUBSCRIPTION, FETCH_ALL_SUBSCRIPTION_SUCCESS,SET_SUBSCRIPTION,SET_ROLE
} from 'constants/subscriptions.constants'
import { startLoader } from 'actions/general.action';

export const setSubscription = (key, value) => {
  return {
    type : SET_SUBSCRIPTION,
    key: key,
    value: value
  }
}

export const setRoles = (key, value) => {
return {
  type: SET_ROLE,
  key:key,
  value:value
}
}

export const fetchSubscriptions = (page) => {
  return dispatch => {
    dispatch({
      type: FETCH_ALL_SUBSCRIPTION,
      payload: page
    })
    dispatch(startLoader())
  }
}

export const fetchSubscriptionsSuccess = (data) => {
  return {
    type: FETCH_ALL_SUBSCRIPTION_SUCCESS,
    payload: data
  };
};

export const deleteSubscription = (id) => {
  return {
    type: DELETE_SUBSCRIPTION,
    payload: id
  };
};

export const editSubscription = (id) => {
  return {
    type: EDIT_SUBSCRIPTION,
    payload: id
  };
};

export const createSubscription = (payload) => {
  console.log(payload)
  return {
    type: CREATE_SUBSCRIPTION,
    payload: payload
  };
};

export const createSubscriptionSuccess = (payload) => {
  return {
    type: CREATE_SUBSCRIPTION_SUCCESS,
    payload: payload
  };
};

export const updateSubscriptionSuccess = (data) => {
  return {
    type: UPDATE_SUBSCRIPTION_SUCCESS,
    payload: data
  };
};

export const deleteSubscriptionSuccess = (data) => {
  return {
    type: DELETE_SUBSCRIPTION_SUCCESS,
    payload: data
  };
};

export const updateSubscription = (payload) => {
  return {
    type: UPDATE_SUBSCRIPTION,
    payload: payload
  };
}; 